import React, { useCallback, useState } from 'react'
import { useFormikContext, useField } from 'formik'
import RegionPicker from '../region-picker'
import { IMAGE_GEEKO_LTD } from '../../../../../constants'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../components/icon/iconfont'

export default props => {

    useStyles(classes)

    const { countries, onlyCountry, disableCountry } = props

    const [show, setShow] = useState(false)

    const {
        setFieldValue,
        touched,
        values
    } = useFormikContext()

    const [field, meta] = useField(props)

    const selectHandle = useCallback(({ country, state, city, zipCodes }) => {
        setFieldValue('country', country)
        if(state){
            setFieldValue('state', state)
        }
        if(city){
            setFieldValue('city', city)
        }
        
        if(zipCodes){
            setFieldValue('zipCodes', zipCodes)
            setFieldValue('zipCode', zipCodes?.[0])
        }
    }, [])

    return <>
        <div className={`${classes.CountryInput} ${!field?.value? classes.Empty: ''}`} onClick={e => {
            if(disableCountry){
                return
            }
            setShow(true)
        }}>
            <div className={classes.Main}>
                <div className={classes.Label}>
                    {props.label}
                </div>
                <div className={classes.Info}>
                    {
                        field.value && <div className={classes.Flag}>
                            <img src={`${IMAGE_GEEKO_LTD}/country/flag/${field.value}.png`} />
                        </div>
                    }
                    <div className={`${classes.Content}  ${disableCountry? classes.Disabled:''}`}>
                        <select {...field}>
                            {
                                countries?.map?.(country => <option value={country?.value} key={country?.value}>{country?.label}</option>)
                            }
                        </select>
                    </div>
                </div>
            </div>
            <Iconfont className={classes.Sword}>&#xe690;</Iconfont>
        </div>
        <RegionPicker onlyCountry={onlyCountry} show={show} countries={countries} country={field.value} onSelect={selectHandle} onClose={() => setShow(false)} />
    </>
}